<template>
  <TabbedBox :useQueryNavigation="true">
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-ordervalue-glass">
        <i class="far fa-layer-group"></i> Glass
      </Tab>
      <Tab tabid="tab-ordervalue-glassService">
        <i class="far fa-tools"></i> Glass Service
      </Tab>
      <Tab tabid="tab-ordervalue-other">
        <i class="far fa-inventory"></i> Other
      </Tab>
      <Tab tabid="tab-ordervalue-stocktype">
        <i class="far fa-clipboard-list-check"></i> Stock Type
      </Tab>
      <Tab tabid="tab-ordervalue-pricegroup">
        <i class="far fa-money-check-edit-alt"></i> Price Group
      </Tab>
      <Tab tabid="tab-ordervalue-squaremeterage">
        <i class="far fa-ruler"></i> Square Meterage
      </Tab>
      <Tab tabid="tab-ordervalue-contact">
        <i class="far fa-user"></i> Contact
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-ordervalue-glass">
        <OrderValueSummaryList title="Glass Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="glassValueList" :monthList="monthList" reportField="orderValueGlassList" />
      </TabPage>
      <TabPage tabid="tab-ordervalue-glassService">
        <OrderValueSummaryList title="Glass Service Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="glassServiceValueList" :monthList="monthList" reportField="orderValueServiceList" />
      </TabPage>
      <TabPage tabid="tab-ordervalue-other">
        <OrderValueSummaryList title="Other Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="otherValueList" :monthList="monthList" reportField="orderValueOtherList" />
      </TabPage>
      <TabPage tabid="tab-ordervalue-stocktype">
        <OrderValueSummaryList title="Stock Type Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="stockTypeValueList" :monthList="monthList" reportField="orderValueStockTypeList" />
      </TabPage>
      <TabPage tabid="tab-ordervalue-pricegroup">
        <OrderValueSummaryList title="Price Group Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="priceGroupValueList" :monthList="monthList" reportField="orderValuePriceGroupList" />
      </TabPage>
      <TabPage tabid="tab-ordervalue-squaremeterage">
        <OrderValueSummaryList title="Stock Square Meterage" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="stockSquareMeterageList" :monthList="monthList" reportField="orderMeterageStockList" />
      </TabPage>
      <TabPage tabid="tab-ordervalue-contact">
        <OrderValueSummaryList title="Contact Value" :startDate="startDate" :endDate="endDate" @applyFilter="applyFilter" @resetFilter="resetFilter" :valueList="contactValueList" :monthList="monthList" reportField="orderValueContactList" />
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import Utils from '@/utils/utils'
import OrderValueSummaryList from '@/modules/intelligence/components/orderValueSummaryList'

export default {
  name: 'OrderValueGroups',
  components: {
    OrderValueSummaryList
  },
  data() {
    return {
      orderSummary: {},

      startDate: moment().local().startOf('year').startOf('day').toDate().toISOString(),
      endDate: moment().local().endOf('year').endOf('day').toDate().toISOString()
    }
  },
  computed: {
    monthList() {
      var maxMonthCount = 18      // No more than 1.5 years

      var monthCount = Math.abs(parseInt(Math.round(moment.duration(moment(this.endDate).diff(this.startDate)).asMonths())))
      monthCount = Math.min(monthCount, maxMonthCount)   

      var outputMonthList = []
      for(var monthIndex=0; monthIndex<monthCount; monthIndex++) {
        let monthStart = moment(this.startDate).local().startOf('month').add(monthIndex, 'months')
        let monthName = monthStart.format('MMM \'YY')

        outputMonthList.push({
          title: monthName,
          index: monthIndex,
          key: monthStart.toISOString(),
          monthStart: monthStart,
          monthEnd: monthStart.clone().endOf('month'),
          month: parseInt(monthStart.format('M')),
          year: parseInt(monthStart.format('YYYY'))
        })
      }

      return outputMonthList
    },
    glassValueList() {
      if(!this.orderSummary.orderValueGlassList)
        return []
      return this.orderSummary.orderValueGlassList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id,

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    glassServiceValueList() {
      if(!this.orderSummary.orderValueServiceList)
        return []
      return this.orderSummary.orderValueServiceList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id,

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    otherValueList() {
      if(!this.orderSummary.orderValueOtherList)
        return []
      return this.orderSummary.orderValueOtherList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id,

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    stockTypeValueList() {
      if(!this.orderSummary.orderValueStockTypeList)
        return []
      return this.orderSummary.orderValueStockTypeList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    priceGroupValueList() {
      if(!this.orderSummary.orderValuePriceGroupList)
        return []
      return this.orderSummary.orderValuePriceGroupList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    },
    stockSquareMeterageList() {
      if(!this.orderSummary.orderMeterageStockList)
        return []
      return this.orderSummary.orderMeterageStockList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatDecimal(group.value, 2, true) + ' m&sup2;',
          stockId: group.id,

          monthList: this.generateMonthList(group, value => { return this.formatDecimal(value, 2, true) + ' m&sup2;' })
        }
      })
    },
    contactValueList() {
      if(!this.orderSummary.orderValueContactList)
        return []
      return this.orderSummary.orderValueContactList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          contactId: group.id,

          monthList: this.generateMonthList(group, this.formatCurrency)
        }
      })
    }    
  },
  mounted() {
    this.requestSummary()

    this.subscribeEndpoint('/orders', () => {
      this.requestSummary()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
  },
  methods: {
    requestSummary() {

      var summaryFilter = {
        startDate: this.startDate,
        endDate: this.endDate,
        maxGroupSize: 0,
        includeMonthBreakdown: true
      }

      this.$apiService.analyticsService.getOrdersValueFullSummary(summaryFilter)
      .then(response => {
        this.orderSummary = response.data
      })
    },
    applyFilter(data) {
      this.startDate = data.startDate
      this.endDate = data.endDate
      
      this.requestSummary()
    },
    resetFilter() {
      this.startDate = moment().local().startOf('month').startOf('day').toDate().toISOString()
      this.endDate = moment().local().endOf('month').endOf('day').toDate().toISOString()

      this.requestSummary()
    },
    generateMonthList(groupRow, formatter) {
      return this.monthList.map(monthInfo => {
        let monthValue = (groupRow.monthList || []).find(monthData => monthData.month == monthInfo.month && monthData.year == monthInfo.year)

        return {
          key: monthInfo.key,
          displayValue: monthValue ? formatter(monthValue.value) : '-'
        }
      })
    }
  }
}
</script>
